import { useAuthStore } from '@/modules/auth/store/auth';

/**
 * Global middleware that prevents merchant or customer from accessing certain pages
 * unless profile setup is completed
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  const {
    user,
    isCustomer,
    isVerified,
    hasCompletedOnboarding,
    hasStripePayoutCompleted,
    hasPersonalDetails,
  } = storeToRefs(useAuthStore());

  const customerProtectedRoutes = [
    '/account/edit-address',
    '/customer/orders',
    '/account/edit-profile',
    '/account/help-center/report-a-problem',
    '/browse/report',
  ];

  const merchantProtectedRoutes = [
    '/merchant/listing',
    '/merchant/orders',
    '/merchant/edit-profile',
    '/merchant/stripe-account',
    '/account/help-center/report-a-problem',
    '/browse/report',
  ];

  if (user.value) {
    // Customer
    if (
      isCustomer.value &&
      customerProtectedRoutes.some((route) => to.path.startsWith(route))
    ) {
      if (!isVerified.value) {
        return navigateTo('/verify');
      }

      if (!hasPersonalDetails.value) {
        return navigateTo('/customer/personal-details');
      }
    }

    // Merchant — /merchant/dashboard is the iPad order board and bypasses Stripe requirement
    else if (!isCustomer.value && to.path.startsWith('/merchant/dashboard')) {
      return;
    }

    // Merchant
    else if (
      !isCustomer.value &&
      merchantProtectedRoutes.some(
        (route) => to.path.startsWith(route) && !hasStripePayoutCompleted.value
      )
    ) {
      if (
        hasCompletedOnboarding.value &&
        (to.path.startsWith('/merchant/listing') ||
          to.path.startsWith('/merchant/orders') ||
          to.path.startsWith('/merchant/edit-profile') ||
          to.path.startsWith('/merchant/stripe-account'))
      ) {
        return;
      }

      return navigateTo('/merchant/business-details');
    }
  }
});
